/**
* DevExpress Dashboard (cells-item-format-rule.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { ModelSerializer } from '@devexpress/analytics-core/analytics-utils';
import * as ko from 'knockout';
import { DashboardItemFormatRule } from './dashboard-item-format-rule';
import { cellsItemFormatRuleSerializationsInfo } from './metadata/_cells-item-format-rule';
export class CellsItemFormatRule extends DashboardItemFormatRule {
    constructor(modelJson = {}, serializer = new ModelSerializer()) {
        super(modelJson, serializer);
        this.addDisposable(this.dataItemApplyToName = ko.computed({
            read: () => this._dataItemApplyToName() || this.dataItemName(),
            write: (val) => this._dataItemApplyToName(val)
        }));
    }
    getInfo() {
        return cellsItemFormatRuleSerializationsInfo;
    }
}
